import { render } from "./ProspectosView.vue?vue&type=template&id=676661b9&ts=true"
import script from "./ProspectosView.vue?vue&type=script&lang=ts"
export * from "./ProspectosView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__